import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { HEALTH_PRODUCTS_PATH } from 'routes/path-names'
import { useShopForHealthBridge } from 'hooks/useShopForHealthBridge'
import { BRIDGE_TRANSFER_LOADING_TEXT } from 'hooks/constants'
import { SaveAndContinueButton } from '../components'
import { getNextBenefitRoute, pushNextBenefitRoute } from '../actions'

const SaveAndContinueButtonGate = ({ onSaveValidate, peekNextRoute, pushNext }) => {
  const { shouldBridge, bridge, isTransferring } = useShopForHealthBridge()

  const saveButtonClick = useCallback(() => {
    const isValidated = onSaveValidate ? onSaveValidate() : true
    if (!isValidated) return
    if (shouldBridge && peekNextRoute() === HEALTH_PRODUCTS_PATH) {
      bridge()
      return
    }
    pushNext()
  }, [onSaveValidate, shouldBridge, peekNextRoute, bridge, pushNext])

  return (
    <SaveAndContinueButton
      saveButtonClick={saveButtonClick}
      disabled={isTransferring}
      loading={isTransferring}
      loadingText={BRIDGE_TRANSFER_LOADING_TEXT}
    />
  )
}

SaveAndContinueButtonGate.displayName = 'SaveAndContinueButtonContainer'
SaveAndContinueButtonGate.propTypes = {
  onSaveValidate: PropTypes.func,
  peekNextRoute: PropTypes.func.isRequired,
  pushNext: PropTypes.func.isRequired,
}

SaveAndContinueButtonGate.defaultProps = {
  onSaveValidate: undefined,
}

export default connect(null, (dispatch, { skipShop }) => ({
  peekNextRoute: () => dispatch(getNextBenefitRoute(null, skipShop)),
  pushNext: () => dispatch(pushNextBenefitRoute(null, skipShop)),
}))(SaveAndContinueButtonGate)
